import { connect } from "react-redux";
import { Button, DialogContentText } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "../../Dialog";
import { handleError } from "../../../reducers/ErrorReducer";
import { notify } from "../../../reducers/NotifierReducer";
import { deleteSearchUser } from "../../../pages/Security/SecFunction";
import { closeRemoveSecUser } from "../../../reducers/DialogsReducer";

const RemoveSecUserDialog = (props) => {
  const { data } = props;
  const close = () => {
    props.closeRemoveSecUser();
  };

  const remove = async () => {
    if (data?.selectedUser) {
      try {
        close();
        await deleteSearchUser(data.selectedUser);
        await data.fetchUsers();
        data.setSelection(null);
        props.notify("User deleted", "success");
      } catch (error) {
        props.handleError(error, "Error Updating User");
      }
    }
  };

  const renderActions = () => {
    return (
      <>
        <Button color="primary" variant="contained" autoFocus onClick={remove}>
          <DeleteIcon /> Remove
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon />
          Close
        </Button>
      </>
    );
  };

  return (
    <Dialog
      toolbar
      title="Remove User"
      actions={renderActions()}
      maxWidth="md"
      fullWidth
    >
      <DialogContentText>
        Are you sure you want to remove user
        <div>
          <b>UserName: {data.userName}</b>
        </div>
      </DialogContentText>
    </Dialog>
  );
};
const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps, {
  closeRemoveSecUser,
  handleError,
  notify,
})(RemoveSecUserDialog);
